// File: src/components/About.js

import React from 'react';

const About = ({ companyData }) => {
  const profileImagePath = '/owner.png'; 
  
  return (
    <div className="about-content">
   <h2 
    className="section-title"
    style={{ color: '#2ECC71',marginTop: '-110px' }} 
    // Emerald Green Accent (Matches the motto color)
>
    About Devulex
</h2>
      <p className="section-subtitle">Delivering robust, full-stack web solutions that power modern businesses.</p>
      
      <div className="about-details-container">
        
        {/* Left Column: Photo/Visual */}
        <div className="about-photo-card">
          <div className="about-image-placeholder">
           <img 
            src={profileImagePath} 
            alt={`Profile picture of ${companyData.owner} (Founder of Devulex)`} 
            className="owner-profile-img" 
            style={{ 
                width: '100%',
                height: '100%',
                objectFit: 'contain', // 🔥 CRITICAL: Ensures the whole image is visible
                borderRadius: '70px' // Maintains the slight rounding
            }}
        />
          </div>
          {/* Enhanced Profile Card Design Element */}
         <div 
    className="profile-card-footer"
    // Inline CSS for the footer container
    style={{
        backgroundColor: '#2C3E50', // Emerald Green Accent (matching your desired color)
        padding: '20px 25px',
        color: 'white',
        textAlign: 'center !important', // 🔥 Justifies (left-aligns) all content within the footer
    }}
>
<p 
        className="owner-role"
        // Inline CSS for the role
        style={{
            fontSize: '1.2em',
            fontWeight: '600',
            marginBottom: '5px',
            opacity: 0.8,
            textAlign: 'center', // Ensure left-alignment
        }}
    >
        Founder & Lead Developer
    </p>            {/* 🔥 CLEANED UP: External CSS now controls size and justification */}
         <h3
        // Inline CSS for the owner's name
        style={{
            fontFamily: 'Montserrat, sans-serif', // Attractive, bold font
            fontSize: '0.9em', // Clear, professional font size
            fontWeight: '700',
            margin: '0',
            textAlign: 'justify', // Ensure left-alignment
        }}
    >
        {companyData.owner}
    </h3>
          </div>
        </div>
        
        {/* Right Column: Text Content */}
      <div 
    className="about-text-content"
    style={{
        // Align all content to the left
        textAlign: 'left',
        // Add a little top padding to align visually with the photo card (adjust as needed)
        paddingTop: '20px', 
    }}
>
    <p 
        className="about-mission"
        style={{
            fontSize: '1.1em',
            lineHeight: '1.7',
            marginBottom: '25px',
            color: '#fff', // Dark gray for body text
            textAlign: 'justify', // Justifies the body text for a formal look
        }}
    >
        Our mission is simple: to leverage Full-Stack Development to solve complex business challenges. Our focus is on glitter technologies—meaning modern, high-performance, and essential tools like React, Node.js, and MongoDB.
    </p>
    
    <p 
        className="about-value"
        style={{
            fontSize: '1.1em',
            lineHeight: '1.7',
            marginBottom: '25px',
            color: '#fff',
            textAlign: 'justify',
        }}
    >
        With a foundation built on years of experience, Devulex offers scalable, robust, and beautifully designed web applications that drive real growth and efficiency for our clients. We believe in transparency, technical excellence, and long-term partnership.
    </p>
    
    <div 
        className="contact-summary-inline"
        style={{ 
            marginTop: '30px', // Add space above the contact info
            paddingTop: '15px', // Optional: creates a small separation line if a border is added
            // BorderTop: '1px solid #ddd', // Uncomment for a subtle separating line
        }}
    >
        <p style={{ fontSize: '1em', marginBottom: '5px', fontWeight: '600',marginTop:'-50px' }}>
            📧 Email: <a href={`mailto:${companyData.email}`} style={{ color: '#2ECC71', textDecoration: 'none' }}>{companyData.email}</a>
        </p>
        <p style={{ fontSize: '1em', marginBottom: '5px', fontWeight: '600' }}>
            📞 Phone: {companyData.phone}
        </p>
    </div>
</div>
      </div>
    </div>
  );
};

export default About;